// src/modules/app-views/_apps/appsindico/units/pages/Init/components/tableColumns/tagColumn.jsx
import translateX from 'utils/translateX';

function tagColumn(buildColumnProps, options = {}) {
  const {
    key = 'tag',
    title = 'unit',
    dataIndex = 'tag',
    width = 120,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: text => {
      return text || '-';
    },
  };
}

export default tagColumn;
